import { ExpenseCategory, ExpenseSubCategory } from '../types';
import { categoryTreeService } from './categoryTreeService';

const expenseCategoryService = categoryTreeService<ExpenseCategory, ExpenseSubCategory>('/expense-categories');

export default expenseCategoryService;
